import { useEffect } from 'react';
import { getSupabaseRuntimeStatus } from './supabaseAdapter';
import { syncTrustedAttemptOutbox } from './outboxSync';

let globalSyncInFlight = false;

async function attemptAutoSync() {
  if (globalSyncInFlight) return;
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return;
  globalSyncInFlight = true;
  try {
    const status = await getSupabaseRuntimeStatus();
    if (!status.configured || !status.authenticated) return;
    await syncTrustedAttemptOutbox({ maxBatch: 20 });
  } catch {
    // Failure is recorded per event by the outbox sync path. Auto-sync remains quiet.
  } finally {
    globalSyncInFlight = false;
  }
}

export function useRuntimeAutoSync() {
  useEffect(() => {
    const online = () => { void attemptAutoSync(); };
    const visible = () => { if (document.visibilityState === 'visible') void attemptAutoSync(); };
    window.addEventListener('online', online);
    document.addEventListener('visibilitychange', visible);
    const timer = window.setInterval(() => { void attemptAutoSync(); }, 30_000);
    void attemptAutoSync();
    return () => {
      window.removeEventListener('online', online);
      document.removeEventListener('visibilitychange', visible);
      window.clearInterval(timer);
    };
  }, []);
}
